import { useCallback } from "react"
import { useDispatch } from "react-redux";
import { deleteAlbumFromQueue } from "../../actions/randomModeActions";

export const useDeleteRandomQueueItem = (album, queueIndex, canDeleteAlbum) => {
    const dispatch = useDispatch();

    return useCallback(() => {
        if(!canDeleteAlbum) return;
        dispatch(deleteAlbumFromQueue(album, queueIndex));
    }, [dispatch, canDeleteAlbum, album, queueIndex]);
}